import React from 'react';
import { useAppConfiguration } from '../../../../AppConfiguration';
import Loader from '../../../pages/Loader';

const LazyLoadedTagDropdown = React.lazy(() => import('./LazyLoadedTagDropdown'));

const TagDropdown = (props) => {
    const {forListing} = props;
    const {[forListing + 'FilterConfiguration']: filterConfiguration} = useAppConfiguration();

    // Tag dropdown needs to be explicitly enabled
    if (!filterConfiguration.tagDropdown?.enabled === true) {
        return null;
    }

    // Lazy load the tag dropdown as not all sites use it (and the dmg calendar doesn't use it at all)
    return (
        <React.Suspense fallback={<Loader />}>
            <LazyLoadedTagDropdown {...props} />
        </React.Suspense>
    );
};

export default TagDropdown;
